import React, { useState, useEffect, useCallback } from "react";
import { setTitle } from "../helpers/MetaTag";
import Table from "../components/elements/table/Table";
import moment from "moment";
import { DragDropContext } from "react-beautiful-dnd";
import { reorder } from "../helpers";
import toastr from "toastr";
import { useSelector } from "react-redux";

import { postData } from "../services/api";
import { useTranslation } from "react-i18next";
import Pagination from "../components/Common/Pagination";
import ManagePasswordPopup from "../components/popup/ManagePasswordPopup";
import { Tooltip } from "react-tooltip";
import EditUserPopup from "../components/popup/EditUserPopup";
import { useNavigate } from "react-router-dom";
import MultipleButtonAction from "../components/elements/multipleButtonAction/MultipleButtonAction";
import AddEditBoardmember from "../components/popup/AddEditBoardmember";

const Users = () => {
  setTitle(
    "Succession Planning Software for your Business with Succession Now | Assign Persons"
  );
  const navigate = useNavigate();
  const { t } = useTranslation();
  const role = localStorage.getItem("role");
  const user = useSelector((state) => state.auth?.user);
  const [loading, setLoading] = useState(true);
  const limit = 10;
  const [offset, setOffset] = useState(0);
  const [sortKey, setSortKey] = useState("created_at");
  const [sortValue, setSortValue] = useState(-1);
  const [sortQuery, setSortQuery] = useState("");
  const [noOfPage, setNoOfPage] = useState(0);
  const [users, setUsers] = useState([]);
  const [totalDataCount, setTotalDataCount] = useState(0);
  const [startDataCount, setStartDataCount] = useState(0);
  const [endDataCount, setEndDataCount] = useState(0);
  const windowUrl = window.location.search;
  const params = new URLSearchParams(windowUrl);

  const othersAction = {
    type: "button",
    link: "/",
    label: t("resend_invitation"),
    icon: "fa-envelope",
    isVisabled: 2,
  };
  const [actionValue, setActionValue] = useState({});
  const [enabledPasswordManagePopup, setEnabledPasswordManagePopup] =
    useState(false);
  const [passwordInfo, setPasswordInfo] = useState({});
  const [userList, setUserList] = useState([]);
  const [selectedRow, setSelectedRow] = useState([]);
  const paramsValue = params.get("user");

  const [isOpen, setIsopen] = useState({
    _id: null,
    open: false,
  });

  const [modalOpen, setModalOpen] = useState({
    open: false,
    data: null,
  });

  const extraData = [
    //(isAdditionalAdministrator && (isAdditionalAdministrator === 1)) &&
    {
      _id: 1,
      label: t("edit"),
      icon: "fa-pen-to-square",
      link: "/",
      type: "button",
      standout: false,
      buttonType: "edit-user-info",
      ordering: 1,
      isVisabled: 1,
    },
    {
      _id: 1,
      label: t("edit"),
      icon: "fa-pen-to-square",
      link: "/",
      type: "button",
      standout: false,
      buttonType: "edit-boardmember",
      ordering: 1,
      isVisabled: 1,
    },
    {
      _id: 2,
      label: t("make_administrators"),
      icon: "fa-arrows-repeat",
      link: "/",
      type: "button",
      standout: false,
      buttonType: "make-administrators",
      isVisabled: [1, 2],
      ordering: 2,
    },
    role && role === "customer-admin"
      ? {
          _id: 3,
          label: t("update_password"),
          icon: "fa-key",
          link: "/",
          type: "button",
          standout: false,
          buttonType: "update-password",
          isVisabled: 1,
          ordering: 3,
        }
      : "",
    {
      _id: 3,
      label: t("make_executive"),
      icon: "fa-mace",
      link: "/",
      type: "button",
      standout: false,
      buttonType: "make-executive",
      isVisabled: 1,
      ordering: 3,
    },
    {
      _id: 4,
      label: t("perspective_board_member"),
      icon: "fa-file-pdf",
      link: "/perspective-board-member?user=${rowId}",
      type: "link",
      buttonType: "perspective-board-member",
      standout: false,
      isVisabled: 1,
      ordering: 4,
    },
    {
      _id: 5,
      label: t("login_as"),
      icon: "fa-external-link",
      type: "button",
      buttonType: "login-as",
      standout: false,
      isVisabled: 1,
      ordering: 5,
    },
  ];

  useEffect(() => {
    if (sortKey && sortValue) {
      setSortQuery({ [sortKey]: sortValue });
    } else {
      setSortQuery("");
    }
  }, [sortKey, sortValue]);

  useEffect(() => {
    if (actionValue && actionValue.button_type === "status") {
      if (user?._id === actionValue?.row_id) {
        toastr.warning("You cannot deactivate your account yourself.");
      } else {
        const loadStatusChange = async () => {
          try {
            const statusData = await postData("assign/status-change", {
              id: actionValue?.row_id,
              status: actionValue?.current_status,
            });
            if (statusData.data) {
              setUsers((users) =>
                users.map((it) => {
                  if (it?._id === statusData.data?._id) {
                    return {
                      ...it,
                      status: actionValue?.current_status,
                    };
                  } else {
                    return it;
                  }
                })
              );
              setActionValue({});
              toastr.success("Status Change successfully.");
            } else {
              toastr.error(statusData.message);
            }
          } catch (error) {
            toastr.error(error.message);
          }
        };
        loadStatusChange();
      }
    } else if (actionValue && actionValue.button_type === "delete") {
      if (user?._id === actionValue?.row_id) {
        toastr.warning("Your account cannot be deleted by yourself.");
      } else {
        const loadDeleteRecord = async () => {
          try {
            const statusData = await postData("assign/delete", {
              id: actionValue?.row_id,
            });
            if (statusData.data) {
              setUsers((users) =>
                users.filter((item) => item._id !== actionValue.row_id)
              );
            } else {
              toastr.error(statusData.message);
            }
          } catch (error) {
            toastr.error(error.message);
          }
        };
        loadDeleteRecord();
      }
    } else if (actionValue && actionValue.button_type === "others") {
      const loadStatusChange = async () => {
        try {
          const othersData = await postData("assign/resend-mail", {
            id: actionValue?.row_id,
          });
          if (othersData.data) {
            toastr.success(
              "Email resent.Please make sure to check your spam email."
            );
          } else {
            toastr.error(othersData.message);
          }
        } catch (error) {
          toastr.error(error.message);
        }
      };
      loadStatusChange();
    } else if (
      actionValue &&
      actionValue.button_type === "make-administrators"
    ) {
      const loadStatusChange = async () => {
        try {
          const othersData = await postData("assign/make-administrators", {
            id: actionValue?.row_id,
            status: actionValue?.current_status,
          });
          if (othersData.data) {
            toastr.success(othersData.message);
          } else {
            toastr.error(othersData.message);
          }
        } catch (error) {
          toastr.error(error.message);
        }
      };
      loadStatusChange();
    } else if (actionValue && actionValue.button_type === "update-password") {
      setEnabledPasswordManagePopup(true);
      const data = userList?.filter((item) => item._id === actionValue?.row_id);
      setPasswordInfo({
        _id: actionValue?.row_id,
        data:
          data &&
          data?.map((item) => ({
            company_name: item?.name ? item?.name : "N/A",
          })),
      });
    } else if (actionValue && actionValue.button_type === "edit-user-info") {
      setIsopen({ open: true, _id: actionValue?.row_id });
    } else if (actionValue && actionValue.button_type === "edit-boardmember") {
      const manageBoardMember = async () => {       
        try {
          const result = await postData("board-member/details", {
            id: actionValue?.row_id
          });
          if (result.status && result.status === 200) {
            setModalOpen({ open: true, data: result?.data });
          } else {
            toastr.error(result.message);
          }
        } catch (error) {
          toastr.error(error.message);
          setLoading(false);
        }
      };
      manageBoardMember();      
    } else if (actionValue && actionValue.button_type === "login-as") {
      if (actionValue?.row_id) {
        navigate(
          `/${actionValue?.button_type + "?user=" + actionValue?.row_id}`
        );
      }
    } else if ( actionValue && actionValue.button_type === "make-executive") {      
      const emp = userList?.find((item) => item._id === actionValue?.row_id);      
      const manageExecutive = async () => {       
        try {
          setLoading(true);
          const firstName = emp.firstName || emp.name?.split(' ')[0]; // Assuming name contains full name
          const lastName = emp.lastName || emp.name?.split(' ')[1];
          const result = await postData("executive/create", {
            employees: [{
              _id: emp?._id,
              label: emp.name,
              value: emp?.email,
              email: emp?.email,
              position: emp?.designation,
              first_name: firstName,
              last_name: lastName,
              isEnabled:true,
              isDisabled: false,
            }],
            sendFor: "new",
          });
          if (result.status && result.status === 200) {
            toastr.success(result.message);
            setLoading(false);
          } else {
            toastr.error(result.message);
            setLoading(false);
          }
        } catch (error) {
          toastr.error(error.message);
          setLoading(false);
        }
      };
      manageExecutive();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [actionValue]);

  const loadList = useCallback(async () => {
    setLoading(true);
    try {
      const result = await postData("assign/list", {
        code: [
          "customer-user",
          "customer-admin",
          "customer-subadmin",
          "customer-boardmember",
        ],
        limit: limit,
        offset: offset,
        sortQuery: sortQuery,
        segment: paramsValue,
        is_invited: 1,
      });
      if (result.data) {
        setUsers(result.data);
        setUserList(result.data);
      }
      setTotalDataCount(result.count);
      setLoading(false);
    } catch (err) {
      setLoading(false);
      console.log(err.message);
    } finally {
      setLoading(false);
    }
  }, [limit, offset, sortQuery, paramsValue]);

  useEffect(() => {
    loadList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loadList]);

  useEffect(() => {
    setNoOfPage(Math.ceil(totalDataCount / limit));
    const startItem = Number(totalDataCount > 0 ? 1 : 0);
    const endItem = Math.min(startItem + limit - 1, totalDataCount);
    setStartDataCount(startItem);
    setEndDataCount(endItem);
  }, [limit, totalDataCount]);

  const handlePageClick = (event) => {
    const newOffset = (event.selected * limit) % totalDataCount;
    console.log(
      `User requested page number ${event.selected}, which is offset ${newOffset}`
    );
    setOffset(newOffset);
    const startItem = Number(newOffset + 1);
    const endItem = Math.min(startItem + limit - 1, totalDataCount);
    setStartDataCount(startItem);
    setEndDataCount(endItem);
  };

  const tableHeadData = [
    {
      _id: 1,
      width: 40,
      name: t("name"),
      value: "name",
      align: "left",
      isSort: true,
      isFilter: false,
    },
    {
      _id: 2,
      width: 15,
      name: t("email"),
      value: "email",
      align: "left",
      isSort: true,
      isFilter: false,
    },
    {
      _id: 12,
      width: 15,
      name: t("role"),
      value: "role",
      align: "left",
      isSort: false,
      isFilter: false,
    },
    {
      _id: 3,
      width: 15,
      name: t("position"),
      value: "title",
      align: "left",
      isSort: true,
      isFilter: false,
    },
    {
      _id: 4,
      width: 20,
      name: t("invitation_sent"),
      value: "created_at",
      align: "left",
      isSort: false,
      isFilter: false,
    },
    {
      _id: 5,
      width: 15,
      name: t("verified"),
      value: "email_verified",
      align: "left",
      isSort: false,
      isFilter: false,
    },
    {
      _id: 6,
      width: 15,
      name: t("status"),
      value: "status",
      align: "left",
      isSort: false,
      isFilter: false,
    },
    {
      _id: 7,
      width: 15,
      name: t("succession_plan"),
      value: "complete_plan",
      align: "left",
      isSort: false,
      isFilter: false,
    },
    {
      _id: 8,
      width: 15,
      name: t("admin"),
      value: "complete_plan",
      align: "left",
      isSort: false,
      isFilter: false,
    },
    {
      _id: 9,
      width: 10,
      name: t("action"),
      value: "",
      align: "right",
      isSort: false,
      isFilter: false,
    },
  ];

  const handleOnDragEnd = async (result) => {
    const items = reorder(users, result.source.index, result.destination.index);
    setUsers(items);

    const res = await postData("position/ordering", {
      items: items,
    });
    if (res.status && res.status === 200) {
      toastr.success(res.message);
    } else {
      toastr.error(res.message);
    }
  };

  const tableData =
    users &&
    Array?.isArray(users) &&
    users?.length > 0 &&
    users?.map((value, key) => {
      let isAdmin = value?.role_details.filter(
        (itm) =>
          itm?.code === "customer-subadmin" || itm?.code === "customer-admin"
      );
      const position =
        value?.position_details &&
        Array?.isArray(value?.position_details) &&
        value?.position_details?.length > 0 &&
        value?.position_details[0];

      return {
        _id: value?._id,
        rowData: [
          // { _id:1, width:40, type:'user', data:value?.creator_name,image:value?.creator_image },
          // { _id:2, width:40, type:'text', data:value?.creator_email },
          {
            _id: 1,
            width: 40,
            type: "user",
            data: value?.name || "N/A",
            shortName: value?.name || "N / A",
          },
          {
            _id: 2,
            width: 15,
            type: "text",
            data: value?.email || "N/A",
          },
          {
            _id: 4,
            width: 15,
            type: "text",
            data: (
              <>
                <div className="flex items-center">
                  <div
                    className={`text-[10px] font-medium leading-tight rounded py-1 px-2  ${
                      value?.role_details &&
                      Array?.isArray(value?.role_details) &&
                      value?.role_details?.length > 0 &&
                      value?.role_details[0]?.code === "customer-boardmember"
                        ? "bg-violet-100 text-violet-600"
                        : "bg-orange-100 text-orange-600"
                    }`}
                  >
                    {
                      value?.role_details &&
                      Array.isArray(value?.role_details) &&
                      value?.role_details?.length > 0
                        ? value?.role_details[0]?.code === "customer-boardmember"
                          ? "Board Member"
                          : value?.executive_details && typeof value?.executive_details === "object" && Object.keys(value?.executive_details).length > 0
                          ? "Executive"
                          : value?.role_details[0]?.name
                        : null
                    }
                  </div>
                </div>
              </>
            ),
            isColor: "",
          },
          {
            _id: 3,
            width: 15,
            type: "text",
            data: (
              <div className="flex flex-col items-start justify-center text-white gap-1">
                {position?.name && (
                  <div className="font-semibold text-slate-600 text-[11px]">
                    <span>{position.name}</span>
                    {position?.short_name && (
                      <div className="font-semibold text-teal-600 text-[11px]">
                        {position.short_name}
                      </div>
                    )}
                  </div>
                )}
              </div>
            ),
          },
          {
            _id: 4,
            width: 20,
            type: "text",
            data:
              value && value?.created_at
                ? moment(new Date(value?.created_at)).format("ll")
                : "N/A",
          },
          {
            _id: 5,
            width: 15,
            type: "text",
            data: (
              <>
                <div
                  className="inline-flex items-center"
                  data-tooltip-id={`email${value?._id}`}
                  data-tooltip-place="right"
                >
                  <div
                    className={`flex items-center text-[10px] font-medium leading-tight rounded py-1 px-2 ${
                      value?.email_verified === 1
                        ? "bg-green-100 text-green-600"
                        : "bg-amber-100 text-amber-600"
                    }`}
                  >
                    <i className="fa-regular fa-envelope mr-1"></i>
                    {value?.email_verified === 1
                      ? t("verified")
                      : t("not_verified")}
                  </div>
                  <Tooltip
                    id={`email${value?._id}`}
                    className="!text-xs !bg-dark-teal-600 z-50 shadow-lg rounded py-3 px-6"
                    render={() => (
                      <div className="gap-x-1">
                        <div className="font-normal leading-none flex items-center">
                          <div className="font-semibold">
                            {value?.email_verified === 1
                              ? "User that has accepted the email invitation"
                              : "User that has not yet accepted the email invitation"}
                          </div>
                        </div>
                      </div>
                    )}
                  />
                </div>
              </>
            ),
          },
          {
            _id: 6,
            width: 15,
            type: "status",
            statusLabel:
              value?.status && value?.status === 1
                ? t("active")
                : t("deactivated"),
            statusType:
              value?.status && value?.status === 1 ? "success" : "warning",
            isTooltip: true,
            toolTipData: (
              <div className="flex flex-col items-start justify-center text-white gap-1">
                {value?.name && (
                  <div className="font-semibold text-slate-200">
                    User that can be login into the successionnow portal
                  </div>
                )}
              </div>
            ),
            data: { _id: value?._id },
          },
          {
            _id: 7,
            width: 15,
            type: "status",
            statusLabel:
              value?.conclusion_details && value?.conclusion_details.length > 0
                ? t("completed")
                : t("incompleted"),
            statusType:
              value?.conclusion_details && value?.conclusion_details.length > 0
                ? "success"
                : "danger",
          },
          {
            _id: 8,
            width: 15,
            type: "status",
            statusLabel: isAdmin && isAdmin.length > 0 ? t("yes") : t("no"),
            statusType: isAdmin && isAdmin.length > 0 ? "success" : "danger",
          },
          user?.role_details[0]?.code === "customer-admin"
            ? {
                _id: 9,
                width: 10,
                type: "action",
                data: [
                  { others: value?.email_verified },
                  { "update-password": value?.email_verified },

                  value?.role_details &&
                  Array?.isArray(value?.role_details) &&
                  value?.role_details?.length > 0 &&
                  value?.role_details[0]?.code === "customer-boardmember"
                    ? ""
                    : { "login-as": 1 },
                  value?.role_details &&
                  Array?.isArray(value?.role_details) &&
                  value?.role_details?.length > 0 &&
                  value?.role_details[0]?.code === "customer-boardmember"
                    ? { "edit-boardmember": 1 }
                    : { "edit-user-info": 1 },
                  value?.role_details &&
                  Array?.isArray(value?.role_details) &&
                  value?.role_details?.length > 0 &&
                  value?.role_details[0]?.code === "customer-boardmember"
                    ? ""
                    : {
                        "make-administrators":
                          value?._id === user?._id
                            ? 3
                            : isAdmin && isAdmin.length > 0
                            ? 2
                            : 1,
                      },
                  value?.role_details &&
                  Array?.isArray(value?.role_details) &&
                  value?.role_details?.length > 0 &&
                  value?.role_details[0]?.code === "customer-boardmember"
                    ? { "perspective-board-member": 1 }
                    : "",
                  value?.role_details &&
                  Array?.isArray(value?.role_details) &&
                  value?.role_details?.length > 0 &&
                  value?.role_details[0]?.code === "customer-boardmember"
                    ? ""
                    : {
                        "make-executive":
                          value?.executive_details && typeof value?.executive_details === "object" && Object.keys(value?.executive_details).length > 0
                            ? 2 : 1,
                      },
                ],
                statusLabel:
                  value?.status && value?.status === 1
                    ? t("active")
                    : t("deactivated"),
                statusType:
                  value?.status && value?.status === 1 ? "success" : "warning",
              }
            : value?.role_details[0]?.code !== "customer-admin"
            ? {
                _id: 9,
                width: 10,
                type: "action",
                data: [
                  { others: value?.email_verified },
                  { "update-password": value?.email_verified },

                  value?.role_details &&
                  Array?.isArray(value?.role_details) &&
                  value?.role_details?.length > 0 &&
                  value?.role_details[0]?.code === "customer-boardmember"
                    ? ""
                    : { "login-as": 1 },
                  value?.role_details &&
                  Array?.isArray(value?.role_details) &&
                  value?.role_details?.length > 0 &&
                  value?.role_details[0]?.code === "customer-boardmember"
                    ? ""
                    : { "edit-user-info": 1 },
                  value?.role_details &&
                  Array?.isArray(value?.role_details) &&
                  value?.role_details?.length > 0 &&
                  value?.role_details[0]?.code === "customer-boardmember"
                    ? ""
                    : {
                        "make-administrators":
                          value?._id === user?._id
                            ? 3
                            : isAdmin && isAdmin.length > 0
                            ? 2
                            : 1,
                      },
                  value?.role_details &&
                  Array?.isArray(value?.role_details) &&
                  value?.role_details?.length > 0 &&
                  value?.role_details[0]?.code === "customer-boardmember"
                    ? { "perspective-board-member": 1 }
                    : "",
                  value?.role_details &&
                  Array?.isArray(value?.role_details) &&
                  value?.role_details?.length > 0 &&
                  value?.role_details[0]?.code === "customer-boardmember"
                    ? ""
                    : {
                        "make-executive":
                          value?.executive_details && typeof value?.executive_details === "object" && Object.keys(value?.executive_details).length > 0
                            ? 2 : 1,
                      },
                ],
                statusLabel:
                  value?.status && value?.status === 1
                    ? t("active")
                    : t("deactivated"),
                statusType:
                  value?.status && value?.status === 1 ? "success" : "warning",
              }
            : "",
        ],
      };
    });

  return (
    <div className="border bg-white border-gray-200 p-4 shadow-md rounded-xl">
      <div className="relative flex justify-between items-center mb-3 gap-4">
        <div className="text-xl md:text-3xl text-slate-800 font-bold mb-6">
          {t("the_following_individuals_have_been_invited_as_users_for") +
            " " +
            user?.company_name}
        </div>

        <div className="flex space-x-2 items-center">
          {/* {
            (role && (role ==='customer-admin' || role ==='customer-subadmin')) && 
            <div className="">
              <Button 
              buttonType={'button'} 
              buttonIcon={'fa-light fa-plus'} 
              buttonIconPosition={'left'} 
              buttonLabel={'Create Succession Plan'} 
              buttonHasLink={true}
              buttonLink={'/assigns'}
              />
            </div>
          } */}
        </div>
      </div>
      <div className="relative flex gap-3 items-center mb-3 flex-wrap">
        <div className="relative">
          <MultipleButtonAction
            selectedRow={selectedRow}
            setSelectedRow={setSelectedRow}
            list={users}
            setList={setUsers}
            loadList={loadList}
            API_URL_STATUS={"assign/status-change"}
            API_URL_DELETE={"assign/delete"}
          />
        </div>
        {/* <div className="relative">
              <Select 
              xPlacement={'left'} 
              dropdownButtonClass={'!bg-white'} 
              selectedValue={limit} 
              dropdownData={[
                  { _id: 1000000, label: 'All Items',value: 1000000 }, 
                  ...[{ _id: 10, label: '10 Items', value: 10 },
                      { _id: 20, label: '20 Items', value: 20 },
                      { _id: 30, label: '30 Items', value: 30 },
                      { _id: 50, label: '50 Items', value: 50 },
                      { _id: 100, label: '100 Items', value: 100 }]
              ]}
              getSelectedValue={(e) => setLimit(e.value)}
              />
          </div> */}
        {/* <div className="relative ml-auto flex justify-end items-center gap-3">
              <div className="relative">
              <Search 
              placeholder={'Search'} 
              setInput={ setKeyword } 
              />
              </div>
              <div className="relative">
              <Select 
              xPlacement={'right'} 
              dropdownButtonClass={'!bg-white'} 
              transitionClass={'!w-auto'}
              selectedValue={emailVerified} 
              dropdownData={[
                  { _id: '', label: 'Select Email Verification' },
                  { _id: 1, label: 'Verified', value: 1 },
                  { _id: 2, label: 'Not Verified', value: 2 },
              ]}
              getSelectedValue={(e) => setEmailVerified(e.value)}
              />
              </div>
              <div className="relative">
              <Select 
              xPlacement={'right'} 
              dropdownButtonClass={'!bg-white'} 
              transitionClass={'!w-auto'}
              selectedValue={status} 
              dropdownData={[
                  { _id: '', label: 'Select Status' },
                  { _id: 1, label: 'Active', value: 1 },
                  { _id: 2, label: 'Deactivated', value: 2 },
              ]}
              getSelectedValue={(e) => setStatus(e.value)}
              />
              </div>
          </div> */}
      </div>
      <DragDropContext onDragEnd={handleOnDragEnd}>
        <div className="w-full rounded-md shadow">
          <Table
            tableData={tableData}
            tableHeadData={tableHeadData}
            totalRecord={totalDataCount}
            loading={loading}
            getSortValue={setSortValue}
            getSortKey={setSortKey}
            // editUrl={"/edit-user"}
            isStatusUpdate={true}
            isDeleteEnabled={true}
            getActionValue={(obj) => setActionValue(obj)}
            othersAction={othersAction}
            // loginAs={"/login-as"}
            isDraggable={false}
            extraData={extraData}
            selectedRow={selectedRow}
            setSelectedRow={setSelectedRow}
            selectable={true}
            forClerify={'user-delete'}
          />
        </div>
      </DragDropContext>
      {noOfPage > 1 ? (
        <Pagination
          handlePageClick={handlePageClick}
          noOfPage={noOfPage}
          startDataCount={startDataCount}
          endDataCount={endDataCount}
          count={totalDataCount}
        />
      ) : (
        <div className="flex justify-center sm:justify-between my-4">
          {totalDataCount > 0 ? (
            <div>
              <p>
                {t("showing")}: {startDataCount} to {endDataCount} of{" "}
                {totalDataCount}
              </p>
            </div>
          ) : (
            ""
          )}
        </div>
      )}
      {enabledPasswordManagePopup && (
        <ManagePasswordPopup
          isOpen={enabledPasswordManagePopup}
          setIsOpen={(val) => setEnabledPasswordManagePopup(val)}
          data={passwordInfo}
          getActionValue={(obj) => {
            setActionValue(obj);
            setEnabledPasswordManagePopup(false);
          }}
        />
      )}
      {isOpen?.open && (
        <EditUserPopup
          isOpen={isOpen?.open}
          id={isOpen?._id}
          setIsOpen={setIsopen}
          loadList={loadList}
        />
      )}
      {
        modalOpen?.open && (
          <AddEditBoardmember
            isOpen={modalOpen?.open}
            setIsOpen={setModalOpen}
            data={modalOpen?.data}
            loadList={loadList}
          />
        )
      }
      
    </div>
  );
};

export default Users;
